import {
    CartEntry,
    CartEntryType,
    EntryWithDevice,
    EntryWithDisney,
    EntryWithESimCard,
    EntryWithGift,
    EntryWithNetflix,
    EntryWithRatePlan,
    EntryWithSimCard,
    EntryWithUpsell,
} from '@telialt/models/src/EshopModel';

export const isEntryWithDevice = (entry: CartEntry): entry is EntryWithDevice =>
    entry?.entryType === CartEntryType.PurchasableProduct;

export const isEntryWithRatePlan = (entry: CartEntry): entry is EntryWithRatePlan =>
    entry?.entryType === CartEntryType.RatePlan;

export const isEntryWithSimCard = (entry: CartEntry): entry is EntryWithSimCard =>
    entry?.entryType === CartEntryType.SimCard;

export const isEntryWithESimCard = (entry: CartEntry): entry is EntryWithESimCard =>
    entry?.entryType === CartEntryType.EsimCard;

export const isEntryWithUpsell = (entry: CartEntry): entry is EntryWithUpsell =>
    entry?.entryType === CartEntryType.UpsellProduct;

export const isEntryWithGift = (entry: CartEntry): entry is EntryWithGift =>
    entry?.giveAway === true && entry?.entryType == null;

export const isEntryWithNetflix = (entry: CartEntry): entry is EntryWithNetflix =>
    entry?.entryType === CartEntryType.Netflix;

export const isEntryWithDisney = (entry: CartEntry): entry is EntryWithDisney =>
    entry?.entryType === CartEntryType.Disney;
